'use strict';

const BaseForwardingAddressModalController=require('./baseForwardingAddressModalController');let

EditForwardingAddressModalController=class EditForwardingAddressModalController extends BaseForwardingAddressModalController{
static get $inject(){
return['$modalInstance','$modal','socketService','uiCommandFactory','onAddressListUpdated','notificationService','uncaughtErrorHandler','emailAddress'];
}

constructor($modalInstance,$modal,socketService,uiCommandFactory,onAddressListUpdated,notificationService,uncaughtErrorHandler,emailAddress){
super($modalInstance,socketService,uiCommandFactory,onAddressListUpdated,notificationService,uncaughtErrorHandler,emailAddress);

this._originalEmailAddress=emailAddress;
this._$modal=$modal;
this._onAddressListUpdated=onAddressListUpdated;
}

async onSubmissionSocketAction(){
return await this._socketService.sendAndWaitForResponse('ReplaceNotificationForwardingAddress',{
original:this._originalEmailAddress,
replacement:this._emailAddress});

}

deleteForwardingAddress(){
this._$modalInstance.close();
this._$modal.open({
templateUrl:'/templates/features/notificationSettings/components/doNotDisturbNotificationSettings/modals/deleteForwardingAddressModalView',
controller:'DeleteForwardingAddressModalController as controller',
resolve:{
emailAddress:()=>this._originalEmailAddress,
onAddressListUpdated:()=>this._onAddressListUpdated}});


}};


module.exports=EditForwardingAddressModalController;
//# sourceMappingURL=editForwardingAddressModalController.js.map
